import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function SpeechIcon(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <g>
                <path d="M462.2,185.7H348.5v16.7h113.7c4,0,7.3,3.3,7.3,7.3v151.9c0,4-3.3,7.3-7.3,7.3h-18c-4.6,0-8.4,3.8-8.4,8.4v34.1l-40-40c-1.8-1.8-4.3-2.7-6.8-2.4H214.9c-4,0-7.3-3.3-7.3-7.3v-5h-16.7v4.9c0,13.2,10.8,24,24,24h171.6l44.8,44.9c2.3,2.3,5.5,3.7,8.7,3.7c1.6,0,3.2-0.3,4.8-1c4.6-1.9,7.6-6.4,7.6-11.4v-36.1h9.7c13.2,0,24-10.8,24-24v-152C486.2,196.5,475.4,185.7,462.2,185.7z" />
                <path d="M440.8,247.6c0-4.6-3.8-8.4-8.4-8.4h-83.9V256h83.9C437,256,440.8,252.2,440.8,247.6z" />
                <path d="M440.8,287.1c0-4.6-3.8-8.4-8.4-8.4h-83.9v16.7h83.9C437,295.5,440.8,291.7,440.8,287.1z" />
                <path d="M439.7,326.6c0-4.6-3.8-8.4-8.4-8.4h-82.8V335h82.8C435.9,335,439.7,331.2,439.7,326.6z" />
                <path d="M326.6,313V161c0-13.2-10.8-24-24-24H55.3c-13.2,0-24,10.8-24,24v152c0,13.2,10.8,24,24,24H65v36.1c0,5,3,9.5,7.6,11.4c1.6,0.7,3.1,1,4.8,1c3.3,0,6.5-1.3,8.7-3.7L131,337h171.6C315.9,337,326.6,326.2,326.6,313z M73.3,320.3h-18c-4,0-7.3-3.3-7.3-7.3V161c0-4,3.3-7.3,7.3-7.3h247.3c4,0,7.3,3.3,7.3,7.3v152c0,4-3.3,7.3-7.3,7.3H128.5c-2.5-0.3-5,0.6-6.8,2.4l-40,40v-34.1C81.7,324,78,320.3,73.3,320.3z" />
                <path d="M85.1,207.3h187.7c4.6,0,8.4-3.8,8.4-8.4c0-4.6-3.8-8.4-8.4-8.4H85.1c-4.6,0-8.4,3.8-8.4,8.4C76.7,203.5,80.5,207.3,85.1,207.3z" />
                <path d="M85.1,246.8h187.7c4.6,0,8.4-3.8,8.4-8.4c0-4.6-3.8-8.4-8.4-8.4H85.1c-4.6,0-8.4,3.8-8.4,8.4C76.7,243,80.5,246.8,85.1,246.8z" />
                <path d="M179,286.3c4.6,0,8.4-3.8,8.4-8.4c0-4.6-3.8-8.4-8.4-8.4H85.1c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4H179z" />
            </g>
        </Icon>
    );
}
